import { render, staticRenderFns } from "./PriceCalculatorWidget.vue?vue&type=template&id=656707a0&"
import script from "./PriceCalculatorWidget.vue?vue&type=script&lang=js&"
export * from "./PriceCalculatorWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports